import { FunctionComponent, useEffect, useState } from "react";
import Listing, { ListingProps } from "./Listing";

type ListingAppProps = {
  listingPageId: string;
};

const ListingApp: FunctionComponent<ListingAppProps> = ({ listingPageId }) => {
  const [listingData, setListingData] = useState<ListingProps>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchListingData = async () => {
      try {
        const response = await fetch(`/api/listing/?contentid=${listingPageId}`);

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setListingData(data);
      } catch (err) {
        setError("Failed to load listing data");
      } finally {
        setLoading(false);
      }
    };

    fetchListingData();
  }, [listingPageId]);

  if (loading) return <p>Loading list...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!listingData) return <p>No listing data available</p>;

  return <Listing heading={listingData.heading}
    initialDetailItems={listingData.initialDetailItems}
    categories={listingData.categories}
    type={listingData.type}
    noHitsText={listingData.noHitsText}
    showOnlyOpenAreaText={listingData.showOnlyOpenAreaText}
    firstCategoryOptionText={listingData.firstCategoryOptionText}
    searchHelpText={listingData.searchHelpText}
    searchLabelText={listingData.searchLabelText}
    producedByAnimalRawText={listingData.producedByAnimalRawText} />;
};

export default ListingApp;
